import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

// Types
import CatalogFilter from '@common/types/catalog/catalog-filter-type';

// Components
import InputField from '@components/form/input';
import SearchIcon from '@components/basics/icons/search';
import { CatalogTabs } from '.';

interface CatalogSearchProps {
  className?: string;
  section: CatalogTabs;
  filterOption: CatalogFilter;
  setFilterOption: React.Dispatch<React.SetStateAction<CatalogFilter>>;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const CatalogSearch: FunctionComponent<CatalogSearchProps> = ({
  className,
  section,
  filterOption,
  setFilterOption,
  isMobile,
}) => {
  const [expanded, setExpanded] = React.useState(isMobile ? true : false);
  const getLabel = () => {
    switch (section) {
      case 'releases':
        return 'CATALOG.SEARCH.LABEL.RELEASE';
      case 'merch':
        return 'CATALOG.SEARCH.LABEL.MERCH';
      case 'nft':
        return 'CATALOG.SEARCH.LABEL.NFT';

      default:
        return 'CATALOG.SEARCH.LABEL.RELEASE';
    }
  };
  return (
    <InputField
      className={`${className || ''} ${!expanded ? 'small' : ''}`}
      name="filter"
      label={expanded && <Translate id={getLabel()} />}
      autoComplete="off"
      value={filterOption?.searchText ?? ''}
      onChange={(value) =>
        setFilterOption({
          ...filterOption,
          searchText: value,
        })
      }
      isGrey
      small
      customBorderRadius="100px"
      leftDecoration={<SearchIcon />}
      onBlur={() =>
        !filterOption?.searchText && !isMobile && setExpanded(false)
      }
      onClick={() => !isMobile && setExpanded(true)}
    />
  );
};

export default connect(mapStateToProps)(styled(CatalogSearch)`
  max-width: 300px;
  width: auto;
  transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    width
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

  input {
    width: auto;
    transition: width
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  label {
    word-break: keep-all;
    white-space: nowrap;
    opacity: 1;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  &.small {
    cursor: pointer;
    width: 50px;

    label {
      opacity: 0;
    }

    .decoration-left {
      left: calc(50% - 3px) !important;
    }

    input {
      width: 50px;
      height: 50px;
      padding: 0;
      pointer-events: none;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.box};
    }
  }
`);
